import {Component, Output, EventEmitter} from '@angular/core';

import {BsModalRef} from 'ngx-bootstrap/modal';
import {WsSpa} from '../../../../services/wsSpa';
import {AlertService} from 'ngx-alerts';

@Component({
  selector: 'app-excluir-usuario',
  templateUrl: './excluir-usuario.component.html'
})
export class ExcluirUsuarioComponent {

  @Output() action = new EventEmitter();
  public usuario;
  public loading = false;

  constructor(private wsSpa: WsSpa,
              private alert: AlertService,
              public  bsModalRef: BsModalRef) {
  }

  public removeUsuario() {
    this.loading = true;
    const usuario = {codigo: this.usuario.id};
    this.wsSpa.setFunction('delete/usuario', usuario, 'spaUrl')
        .subscribe(
            data => this.trataRetorno(data),
            error => this.trataErro(error.message)
        );
  }

  public trataRetorno(retorno) {
    this.loading = false;
    if (retorno['status'] === 'OK') {
      this.alert.success(retorno['mensagem']);
      this.action.emit(true);
      setTimeout(() => {
        this.bsModalRef.hide();
      }, 1000);
    } else {
      this.alert.danger(retorno['mensagem'])
    }
  }

  public trataErro(error) {
    this.loading = false;
    this.alert.danger(error);
  }

}
